export default __webpack_public_path__ + "static/media/icons8-fish-100.ef91a502.svg";